'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/~/has/src/index.js
// module id = CQU7
// module chunks = 0